<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 3H18C18.5523 3 19 3.44772 19 4V20C19 20.5523 18.5523 21 18 21H8C7.44772 21 7 20.5523 7 20V17.5C7 17.2239 6.77614 17 6.5 17H5.5C5.22386 17 5 17.2239 5 17.5V20C5 21.6569 6.34315 23 8 23H18C19.6569 23 21 21.6569 21 20V4C21 2.34315 19.6569 1 18 1H8C6.34315 1 5 2.34315 5 4V6.5C5 6.77614 5.22386 7 5.5 7H6.5C6.77614 7 7 6.77614 7 6.5V4C7 3.44772 7.44771 3 8 3Z"
      fill="#152E39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3536 7.64652C12.5488 7.45126 12.8654 7.45126 13.0607 7.64652L17.0607 11.6465C17.2559 11.8418 17.2559 12.1584 17.0607 12.3536L13.0607 16.3536C12.8654 16.5489 12.5488 16.5489 12.3536 16.3536L11.6464 15.6465C11.4512 15.4513 11.4512 15.1347 11.6464 14.9394L13.5858 13.0001H3.5C3.22386 13.0001 3 12.7762 3 12.5001V11.5001C3 11.2239 3.22386 11.0001 3.5 11.0001H13.5858L11.6464 9.06074C11.4512 8.86547 11.4512 8.54889 11.6464 8.35363L12.3536 7.64652Z"
      fill="#152E39"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      default: 186,
      type: Number,
    },
    heigth: {
      default: 148,
      type: Number,
    },
  },
}
</script>
